import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import CreateCampaignPage from "./pages/CreateCampaignPage";
import CampaignsPage from "./pages/CampaignsPage";
import CampaignRouter from "./pages/CampaignRouter";
import InfluencerProfilePage from "./pages/InfluencerProfilePage";
import InfluencerCampaignPerformancePage from "./pages/InfluencerCampaignPerformancePage";
import InfluencerLinksPage from "./pages/InfluencerLinksPage";
import EditLinksPage from "./pages/EditLinksPage";
import EditCampaignPage from "./pages/EditCampaignPage";
import PublisherProfilePage from "./pages/PublisherProfilePage";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminCampaignReviewPage from "./pages/AdminCampaignReviewPage";
import AdminPublisherDetailPage from "./pages/AdminPublisherDetailPage";
import AdminInfluencerDetailPage from "./pages/AdminInfluencerDetailPage";
import TermsPage from "./pages/TermsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/links/edit"
            element={
              <PrivateRoute>
                <EditLinksPage />
              </PrivateRoute>
            }
          />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/:slug" element={<InfluencerLinksPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <PrivateRoute>
                <CampaignsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/create"
            element={
              <PrivateRoute>
                <CreateCampaignPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/:id/edit"
            element={
              <PrivateRoute>
                <EditCampaignPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/:id"
            element={
              <PrivateRoute>
                <CampaignRouter />
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/:id/performance"
            element={
              <PrivateRoute>
                <InfluencerCampaignPerformancePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <InfluencerProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/publisher-profile"
            element={
              <PrivateRoute>
                <PublisherProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboardPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/campaigns/:id"
            element={
              <AdminRoute>
                <AdminCampaignReviewPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/publishers/:publisherId"
            element={
              <AdminRoute>
                <AdminPublisherDetailPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/influencers/:influencerId"
            element={
              <AdminRoute>
                <AdminInfluencerDetailPage />
              </AdminRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
